/**
 * Master
 *  マスターデータを扱う
 */

import master from "../../api/master"

export default {
  namespaced: true,
  state: {
    partsPrice: null,
    masterBilling: null
  },
  actions: {
    // PartsPrice API
    createPartsPrice ({commit}, data) {
      master.createPartsPrice(data)
        .then((d) => {
          commit('CREATE_PARTS_PRICE', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getPartsPrice ({commit}, id) {
      master.getPartsPrice(id)
        .then((d) => {
          commit('GET_PARTS_PRICE', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updatePartsPrice ({commit}, data) {
      master.updatePartsPrice(data)
        .then((d) => {
          commit('UPDATE_PARTS_PRICE', d.data)
          alert('保存しました')
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deletePartsPrice ({commit}, id) {
      master.deletePartsPrice(id)
        .then((d) => {
          commit('DELETE_PARTS_PRICE', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // Billing API
    getBilling ({commit}, id) {
      master.getBilling(id)
        .then((d) => {
          commit('GET_BILLING', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateBilling ({commit}, data) {
      master.updateBilling(data)
        .then((d) => {
          commit('UPDATE_BILLING', d.data)
          alert('保存しました')
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // send email API
    sendEmail ({commit}, data) {
      return master.sendEmail(data)
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    },
    sendEmailContent ({commit}, data) {
      return master.sendEmailContent(data)
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    },
    notifyTool ({commit}, data) {
      return master.notifyTool(data)
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    }
  },
  mutations: {
    // PartsPrice API
    CREATE_PARTS_PRICE (state, data) {
      state.partsPrice.push(data)
    },
    GET_PARTS_PRICE (state, data) {
      state.partsPrice = data
    },
    UPDATE_PARTS_PRICE (state, data) {
      for (let i in state.partsPrice) {
        if (state.partsPrice[i].pk === data.pk) {
          state.partsPrice.splice(i, 1, data)
          return
        }
      }
    },
    DELETE_PARTS_PRICE (state, pk) {
      for (let i in state.partsPrice) {
        if (state.partsPrice[i].pk === pk) {
          state.partsPrice.splice(i, 1)
          return
        }
      }
    },
    // billing API
    GET_BILLING (state, data) {
      state.masterBilling = data[0]
    },
    UPDATE_BILLING (state, data) {
      state.masterBilling = data
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/master.js